<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
#app, html, body {
  width: 100%;
  height: 100%;
  font-style: "Microsoft YaHei";
  font-size: 14px
}
</style>



// WEBPACK FOOTER //
// src/App.vue